export const enClientPortalMarketDataPages = {
    marketData: {
        explorer: {
            title: 'Analysis',
            demoLabel: 'DEMO',
            demoTooltip: 'For this demo, we only provide sample data.',
        },
        demoCity: 'Sample city',
        unitPrefix: 'in {{unit}}',
        noSelection: {
            selectAssetOrCustomLocation: 'Select an asset or custom location using address search.',
            selectAsset: 'Select an asset to view market data.',
        },
        noData: {
            lineOne: 'No data can be displayed for your selection.',
            lineTwo: 'Please try again later.',
            imageAlt: 'No data placeholder',
        },
        sidebar: {
            title: 'Selection',
            customLocation: 'Custom location',
            emptyText: 'You can select assets here once a corresponding appraisal has been completed.',
        },
        search: {
            title: 'Custom location',
            coordinateError: 'No coordinates could be loaded for this search.',
            cancel: 'Cancel',
            next: 'Next',
            googleSearchBar: {
                noMatchingAddress: 'No matching address found',
                enterAddressToShowOptions: 'Enter an address to show options',
                consentRequiredLabel: 'To use address search, please allow Google Maps',
                searchLabel: 'Search address',
            },
        },
        sidebarSelection: {
            marketValue: 'Market value',
            marketRent: 'Market rent',
            managementCosts: 'Management costs',
            grossYield: 'Yield (gross yield)',
        },
        stats: {
            maximum: 'Maximum',
            average: 'Average',
            minimum: 'Minimum',
        },
        categories: {
            apartments: 'Apartments',
            houses: 'Houses',
            office: 'Office',
            retail: 'Retail',
            logistics: 'Logistics',
            other: 'More',
        },
        topics: {
            price_apartment_new: 'Condominium purchase price, new build',
            price_apartment_existing: 'Condominium purchase price, existing',
            rent_apartment_new: 'Rent, new build',
            rent_apartment_existing: 'Rent, existing',
            price_plot_single_family_house: 'Single-family house plot purchase price',
            price_single_family_house: 'Single-family house purchase price',
            price_townhouse_new: 'Terraced house purchase price, new build',
            price_townhouse_existing: 'Terraced house purchase price, existing',
            retail_rent_city: 'Retail rent in prime high-street locations',
            retail_rent_1b: 'Retail rent in secondary high-street locations',
            retail_yield_central: 'Net initial yield, central retail locations',
            retail_yield_decentral: 'Net initial yield, decentral retail locations',
            office_rent_city: 'Office rent, city',
            office_rent_fringe: 'Office rent, city fringe',
            office_rent_suburb: 'Office rent, periphery',
            office_rent_agglomeration: 'Office rent, office centers',
            logistics_rent_logistics: 'Logistics and warehouse rent',
            logistics_rent_service: 'Service-area rent',
            logistics_yield_logistics: 'Net initial yield, warehouses',
            logistics_yield_industrial: 'Net initial yield, industrial space',
            logistics_yield_logistics_prime: 'Net initial yield, warehouses, prime yield',
            logistics_yield_industrial_prime: 'Net initial yield, industrial space, prime yield',
            area: 'Area',
            gross_domestic_product: 'Gross domestic product',
            gross_domestic_product_ranking: 'Gross domestic product ranking',
            employment: 'Employment',
            unemployment: 'Unemployment rate',
            unemployment_ranking: 'Unemployment rate ranking',
            population: 'Population',
            building_permit_apartments: 'Building permits',
            population_density: 'Population density',
            population_ranking: 'Population ranking',
            retail_rent_secondary: 'Retail rent in district locations',
            office_yield_decentral: 'Net initial yield, decentral office locations',
            office_yield_central: 'Net initial yield, central office locations',
        },
        descriptions: {
            marketValue: 'Market value in €',
            marketValuePerArea: 'Market value in €/m² {{areaLabel}}',
            landValuePerArea: 'Land value in €/m² land area',
            monthlyMarketRentPerArea: 'Monthly market rent in €/m² {{areaLabel}}',
            rentableArea: 'rentable area',
            livingArea: 'living area',
            usableArea: 'usable area',
        },
    },
}
